import { Injectable } from '@angular/core';

declare global {
	interface Window {
		dataLayer?: any[];
	}
}

export type ServiceOptionCategory = 'internal' | 'external';

export interface ServiceOptionClickPayload {
	service_category: ServiceOptionCategory;
	service_type: 'pickup' | 'delivery' | 'external';
	provider: 'losteria' | 'uber_eats' | 'wolt' | 'lieferando' | string;
	venue_id?: string;
	venue_name?: string;
	link?: string;
}

@Injectable({
	providedIn: 'root',
})
export class GtmService {
	push(event: string, payload: Record<string, any> = {}): void {
		try {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({ event, ...payload });
		} catch (e) {
			console.warn('GTM push failed', e);
		}
	}

	trackServiceOptionClick(payload: ServiceOptionClickPayload): void {
		this.push('service_option_click', payload);
	}
}
